import React from "react";

export default function PrivacyPolicy() {
  return (
    <main data-testid="privacy-page" className="pt-28 pb-16 px-4">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl sm:text-4xl font-['Playfair_Display'] text-white mb-8">Privacy Policy</h1>
        <div className="prose prose-invert max-w-none space-y-6 text-gray-400">
          <p className="text-sm">Last updated: January 2026</p>
          <h2 className="text-white text-xl font-semibold mt-8">1. Information We Collect</h2>
          <p>At Digitronix Consultancy LLC, we collect information you provide directly to us, such as when you contact us, request a quote, or subscribe to our newsletter. This may include your name, email address, and message content.</p>
          <h2 className="text-white text-xl font-semibold mt-8">2. How We Use Your Information</h2>
          <p>We use the information we collect to respond to your inquiries, provide our services, send you technical notices and updates, and improve our services and communication.</p>
          <h2 className="text-white text-xl font-semibold mt-8">3. Information Sharing</h2>
          <p>We do not sell, trade, or rent your personal information to third parties. We may share information with service providers who assist us in operating our business, provided they agree to keep this information confidential.</p>
          <h2 className="text-white text-xl font-semibold mt-8">4. Data Security</h2>
          <p>We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.</p>
          <h2 className="text-white text-xl font-semibold mt-8">5. Contact Us</h2>
          <p>If you have any questions about this Privacy Policy, please contact us at info@digitronixconsultancyllc.com</p>
        </div>
      </div>
    </main>
  );
}
